exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-clockText-2QDh5{margin:auto 8px;color:#ebebeb;font-size:16px;font-weight:700;font-family:DIN Alternate;text-align:left}", ""]);

// Exports
exports.locals = {
	"clockText": "index-clockText-2QDh5"
};